<span style="float:left" *ngIf="backToCustomerId">
    <button nz-button (click)="navigateBackToCustomer()"><span nz-icon nzType="left" nzTheme="outline"></span>BACK</button>
</span>
<div nz-row *ngIf="quote.specialPriceSetName">
    <div nz-col nzXs="24" nzSm="20" nzMd="16" nzLg="12" nzXl="8" nzXXl="6" style="margin-bottom: 10px;">
        <nz-alert nzType="warning" nzMessage="Special Pricing Active: {{quote.specialPriceSetName}}" nzShowIcon></nz-alert>
    </div>
    <div>
        <button nz-button style="height: 40px; font-size: 1rem; margin-left: 10px" (click)="isFleetAuthModalVisible = true" [nz-tooltip]="'View Authorisation'"
        [nzLoading]="isLoading" *ngIf="(quote.authType != null && quote.isAuthorised != null)">
        <span nz-icon [nzType]="quote.isAuthorised ? 'check-circle' : 'close-circle'" nzTheme="fill" 
            style="font-size: 1.5rem; vertical-align: middle; margin-top: -6px;"></span>{{quote.isAuthorised ? 'Authorised' : 'Declined'}}
    </button>
</div>
    
</div>

<div nz-row class="text-div" *ngIf="authService.user.posLevel === 0">
    
    <div nz-col nzXs="24" nzSm="8" nzMd="8" nzLg="8" nzXl="8" nzXXl="8" class="text-center">
        <span class="text-style">Quote :</span> {{quote.quoteRef}} <input (focusout)="quote.markDirty()" (keydown.enter)="quote.markDirty()" nz-input placeholder="Customer Order Reference" [(ngModel)]="quote.customerOrderReference" [disabled]="quote.isCompleted" style="display: inline; width: 200px;">
    </div>
    <div nz-col nzXs="24" nzSm="8" nzMd="8" nzLg="8" nzXl="8" nzXXl="8" class="text-center">
        <span class="text-style">Date :</span> {{quote.dt_processed | date}}
    </div>
    <div nz-col nzXs="24" nzSm="8" nzMd="8" nzLg="8" nzXl="8" nzXXl="8" class="text-center">
        <span class="text-style">Salesman : </span>
        <span *ngIf="!authService.hasClaims(['SDRP'])">{{quote.userFullname}} {{ quote.userCell }}</span>
        <nz-select [disabled]="quote.isCompleted" *ngIf="authService.hasClaims(['SDRP'])" (ngModelChange)="changeSalesman($event)" style="width: 50%;" nzPlaceHolder="Select Salesman" [(ngModel)]="assignedSalesman">
            <nz-option *ngFor="let user of salesmen" [nzValue]="user.userId" [nzLabel]="user.fullname + ' - ' + user.cell"></nz-option>
        </nz-select>
    </div>
</div>

<div *ngIf="quote.quoteActionValue" class="quote-action-header">
    <span>Last quote action: <strong>{{quote.quoteActionStatus}}</strong></span>
    <a [href]="quoteActionWebsiteUrl" target="_blank" rel="noopener noreferrer">
        View {{quoteActionWebsiteBrand}} quote <span nz-icon nzType="export" nzTheme="outline" aria-hidden="true"></span>
    </a>
</div>

<div nz-row *ngIf="authService.user.posLevel === 1">
    <div nz-col nzSpan="24">
        <app-pos-basic-actions [(quote)]="quote" [isLoading]="isLoading" (statusChange)="showStatusModal($event)" (addItems)="addItemsToQuote($event)"></app-pos-basic-actions>
        <nz-divider style="margin-top: 29px;margin-bottom: 27px;"></nz-divider>
    </div>
</div>

<div nz-row  *ngIf="authService.user.posLevel === 0">
    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="9" nzXXl="9">
        <nz-divider nzText="Customer"></nz-divider>
        <div nz-row nzJustify="center">
            <div nz-col nzXs="22" nzSm="22" nzMd="22" nzLg="22" nzXl="22" nzXXl="22">
                <app-pos-customer-details [(quote)]="quote" [isLoading]="isLoading"></app-pos-customer-details>
            </div>
        </div>
    </div>
    <div nz-col nzXs="24" nzSm="12" nzMd="12" nzLg="12" nzXl="9" nzXXl="9">
        <nz-divider nzText="Vehicle"></nz-divider>
        <div nz-row nzJustify="center">
            <div nz-col nzXs="22" nzSm="22" nzMd="22" nzLg="22" nzXl="22" nzXXl="22">
                <app-pos-vehicle-details [(quote)]="quote" [isLoading]="isLoading" (onVehicleSave)="saveVehicle($event)" [setVehicleId]="externalVehicleId"></app-pos-vehicle-details>
            </div>
        </div>
    </div>
    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="6" nzXXl="6">
        <nz-divider style="margin-top: 29px;margin-bottom: 27px;"></nz-divider>
        <app-pos-actions [(quote)]="quote" [isLoading]="isLoading" (statusChange)="showStatusModal($event)" (addItems)="addItemsToQuote($event)"></app-pos-actions>
    </div>

</div>
<!-- <nz-tabset nzCentered>
    <nz-tab *ngFor="let tab of this.tableOrder" nzTitle="{{tab.name}}"> -->
<app-quote-lines [quote]="quote" [isLoading]="isLoading" (addItems)="addItemsToQuote($event)"></app-quote-lines>
<!-- </nz-tab>
</nz-tabset> -->

<!-- Bottom row of strip buttons -->
<div nz-row nzJustify="center" style="padding-top: 30px;" *ngIf="((this.quote.isCompleted == false && this.quote.authType === 0) || (this.quote.isCompleted == false && this.quote.authType != null && this.quote.isAuthorised == true)) && (authService.user.posLevel === 0)">
    <div nz-col nzXs="24" nzSm="24" nzMd="5" nzLg="5" nzXl="4" nzXXl="4">
        <div *ngIf="this.quote.lines && this.quote.lines.length > 0 && this.quote.isWIP === false">
            <button nz-button nzType="default" class="btn submit float-left" style="height: 40px; font-size: 1rem; padding-bottom: 1rem;" (click)="tentativelyAccept()" [disabled]="!this.quote.hasCustomer" [nz-tooltip]="!this.quote.hasCustomer ? 'Select Customer Details First!' : ''"
                [nzLoading]="quote.isDirty" *ngIf="!authService.hasClaims(['WIP'])">
                <i nz-icon nzType="clock-circle" nzTheme="fill"
                    style="font-size: 1.5rem; vertical-align: middle; margin-top: -6px;"></i> Tentatively Accept
            </button>
            <button nz-button nzType="default" *ngIf="this.authService.user.bookingsEnabled === true" class="btn submit float-left" style="height: 40px; font-size: 1rem; margin-left: 1rem; margin-bottom: 1rem;" (click)="onBookingClick()" [disabled]="!checkCanClickComplete()"
                [nz-tooltip]="getCompleteButtonTooltip()" [nzLoading]="quote.isDirty" [ngClass]="{'text-info-style' : quote.booking}">
                <i nz-icon nzType="calendar" nzTheme="fill"
                    style="font-size: 1.5rem; vertical-align: middle; margin-top: -6px; "
                    ></i> {{quote.booking ? 'BOOKED: ' + quote.booking.dateBooked + ' ' + quote.booking.timeBooked.toString().padStart(2,"0").substring(0,5) : 'Booking'}}
            </button>
        </div>
        <div *ngIf="this.quote.isWIP">
            <button nz-button nzType="default" class="btn submit float-left" style="height: 40px; font-size: 1rem;  margin-bottom: 1rem;" (click)="cancelJobCard()" [disabled]="!this.quote.hasCustomer || !authService.hasClaims(['CJC'])" [nz-tooltip]="!this.quote.hasCustomer ? 'Select Customer Details First!' : ''"
                [nzLoading]="quote.isDirty" *ngIf="this.quote.isWIP">
                <i nz-icon nzType="close-circle" nzTheme="fill"
                    style="font-size: 1.5rem; vertical-align: middle; margin-top: -6px;"></i> Cancel Jobcard
            </button>
        </div>
        <div *ngIf="this.quote.wbcActive">
            <app-pos-wbc [(quote)]="quote" [isLoading]="isLoading" ></app-pos-wbc>
        </div>
    </div>
    <div nz-col nzXs="24" nzSm="24" nzMd="19" nzLg="19" nzXl="16" nzXXl="16" *ngIf="authService.hasClaims(['WIP']) && authService.user.featureLevel >= 2">
        <div *ngIf="this.quote.lines && this.quote.lines.length > 0 && this.quote.isWIP === false" class="text-center">
            <span class="mobile" style="font-size: 1rem;">Work In Progress:</span>
            <nz-button-group style="padding-inline: 1rem;">
                <button nz-button nzType="default" nzSize="large" class="btn submit text-center" (click)="this.startDemandAssignment()" [disabled]="!checkCanClickComplete()" [nz-tooltip]="getCompleteButtonTooltip()"
                    [nzLoading]="quote.isDirty" [ngClass]="{'text-info-style' : quote.booking}"> <!--assignWIP(true)-->
                    <i nz-icon nzType="plus-circle" nzTheme="fill"
                        style="font-size: 1.5rem; vertical-align: middle; margin-top: -6px;"
                        ></i> 
                        <span>Reserve</span>&nbsp;<span class="mobile"> Stock</span>
                </button>
                <button nz-button nzType="default" nzSize="large" class="btn submit text-center" (click)="assignWIP(false)" [disabled]="!checkCanClickComplete()" [nz-tooltip]="getCompleteButtonTooltip()"
                    [nzLoading]="quote.isDirty" [ngClass]="{'text-info-style' : quote.booking}">
                    <i nz-icon nzType="minus-circle" nzTheme="fill"
                        style="font-size: 1.5rem; vertical-align: middle; margin-top: -6px;"
                        ></i> 
                        <span>Dont Reserve</span>&nbsp;<span class="mobile"> Stock</span>
                </button>
                <button nz-button nzType="default" class="btn submit" style="height: 40px; font-size: 1rem;" (click)="isFleetAuthModalVisible = true" [nz-tooltip]="'View Authorisation'"
                [nzLoading]="isLoading" *ngIf="this.quote.authType != null && this.quote.isAuthorised != null">
                <i nz-icon nzType="check-circle" nzTheme="fill" 
                    style="font-size: 1.5rem; vertical-align: middle; margin-top: -6px;"></i>Authorisation
            </button>
            </nz-button-group>
        </div>
        <div *ngIf="this.quote.lines && this.quote.lines.length > 0 && this.quote.isWIP === true && quote.quoteStatusId === 26" class="text-center">
            <nz-button-group style="padding-inline: 1rem;">
                <button nz-button nzType="default" nzSize="large" class="btn submit text-center" (click)="assignWIP(true)" [disabled]="!checkCanClickComplete()" [nz-tooltip]="getCompleteButtonTooltip()"
                    [nzLoading]="quote.isDirty" [ngClass]="{'text-info-style' : quote.booking}">
                    <i nz-icon nzType="plus-circle" nzTheme="fill"
                        style="font-size: 1.5rem; vertical-align: middle; margin-top: -6px;"
                        ></i> 
                        <span>Reserve</span>&nbsp;<span class="mobile"> Stock</span>
                </button>
                
            </nz-button-group>
        </div>
    </div>
    <div nz-col nzXs="0" nzSm="0" nzMd="16" nzLg="16" nzXl="16" nzXXl="16" *ngIf="!authService.hasClaims(['WIP']) || authService.user.featureLevel < 2">
    </div>
    <div nz-col nzXs="24" nzSm="24" nzMd="4" nzLg="4" nzXl="4" nzXXl="4" *ngIf="(authService.hasClaims(['WIP']) && this.quote.isWIP === true) || (!authService.hasClaims(['WIP']) || (authService.user.featureLevel < 2)); else noSaveTemplate">
        <button nz-button nzType="default" *ngIf="this.quote.lines && this.quote.lines.length > 0" class="btn submit float-right" style="height: 40px; font-size: 1rem;" (click)="(this.quote.isWIP && authService.user.featureLevel === 3) ? saleModal() : completeSale()" [disabled]="!checkCanClickComplete()" [nz-tooltip]="getCompleteButtonTooltip()"
            [nzLoading]="quote.isDirty">
            <i nz-icon nzType="check-circle" nzTheme="fill" 
                style="font-size: 1.5rem; vertical-align: middle; margin-top: -6px;"></i><span *ngIf="!this.quote.isWIP || authService.user.featureLevel < 3">Complete Sale</span><span *ngIf="this.quote.isWIP && authService.user.featureLevel === 3">Invoice Customer</span>
        </button>
        <button nz-button nzType="default" class="btn submit" style="height: 40px; font-size: 1rem;" (click)="isFleetAuthModalVisible = true" [nz-tooltip]="'View Authorisation'"
        [nzLoading]="isLoading" *ngIf="this.quote.authType!=null && this.quote.isAuthorised != null">
        <i nz-icon nzType="check-circle" nzTheme="fill" 
            style="font-size: 1.5rem; vertical-align: middle; margin-top: -6px;"></i>Authorisation
    </button>
    </div>
    <ng-template #noSaveTemplate>
        <div nz-col nzXs="0" nzSm="0" nzMd="4" nzLg="4" nzXl="4" nzXXl="4"></div>
    </ng-template>
</div>

<div nz-row nzJustify="center" *ngIf="authService.user.posLevel === 1">
    <div nz-col nzSpan="4" class="text-center">
        <button nz-button nzType="primary" [nzLoading]="isLoading" (click)="closeBasicQuote()">Close Quote</button> 
    </div>

</div>
<!-- Row of buttons if quote is completed -->
<div nz-row nzJustify="center" *ngIf="this.quote.isCompleted">
    <div nz-col nzXs="24" nzSm="24" nzMd="5" nzLg="5" nzXl="4" nzXXl="4">
        <nz-button-group>
            <button nz-button nzType="default" class="btn submit" style="height: 40px; font-size: 1rem;" (click)="onReactivateClick()" [nz-tooltip]="'Reactivate this quote'"
                [nzLoading]="isLoading" *ngIf="!this.quote.isConvertedToSale">
                <i nz-icon nzType="check-circle" nzTheme="fill" 
                    style="font-size: 1.5rem; vertical-align: middle; margin-top: -6px;"></i>Reactivate
            </button>
            <button nz-button nzType="default" class="btn submit" style="height: 40px; font-size: 1rem;" (click)="onRequoteClick()" [nz-tooltip]="'Requote this quote'"
                [nzLoading]="isLoading">
                <i nz-icon nzType="check-circle" nzTheme="fill" 
                    style="font-size: 1.5rem; vertical-align: middle; margin-top: -6px;"></i>Requote
            </button>
        </nz-button-group>
    </div>
</div>
<!-- Fleet Buttons -->
<div nz-row nzJustify="center" *ngIf="!this.quote.isCompleted && this.quote.authType === 1 && quote.isAuthorised == null">
    <div nz-col nzXs="24" nzSm="24" nzMd="5" nzLg="5" nzXl="4" nzXXl="4">
        <nz-button-group>
            <button nz-button nzType="default" class="btn submit" style="height: 40px; font-size: 1rem;" (click)="isFleetAuthModalVisible = true" [nz-tooltip]="'Send for Authorisation'"
                [nzLoading]="isLoading">
                <i nz-icon nzType="check-circle" nzTheme="fill" 
                    style="font-size: 1.5rem; vertical-align: middle; margin-top: -6px;"></i>Send for Authorisation
            </button>
        </nz-button-group>
    </div>
</div>

<div nz-row nzJustify="center" *ngIf="quote.authType==2 && quote.isAuthorised == null">
    <div nz-col nzXs="24" nzSm="24" nzMd="5" nzLg="5" nzXl="4" nzXXl="4">
        <nz-button-group>
            <button nz-button nzType="default" class="btn submit" style="height: 40px; font-size: 1rem;" (click)="isFleetAuthModalVisible = true" [nz-tooltip]="'Check Authorisation from the Call Center'"
                [nzLoading]="isLoading">
                <i nz-icon nzType="check-circle" nzTheme="fill" 
                    style="font-size: 1.5rem; vertical-align: middle; margin-top: -6px;"></i>{{ quote.fleetStateId === 2 || quote.fleetStateId === 4 || quote.fleetStateId === 5 || quote.fleetStateId === 10
  ? 'Check '
  : 'Send for ' }} Authorisation
            </button>
        </nz-button-group>
    </div>
</div>

<!-- MODALS -->


<!-- Nav Away Modal -->

<nz-modal [(nzVisible)]="isNavModalVisible" nzTitle="Update Status" (nzOnCancel)="isNavModalVisible = false; navPathAway='';" [nzFooter]="null" nzWidth="800px">
    <div *nzModalContent>

        <!--Classification-->
        <ng-container *ngIf="this.quote.leadChannel || this.quote.leadType then classification"></ng-container>
        <div nz-row [nzGutter]="5" [nzJustify]="'center'">
            <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" style="text-align: center;">
                <br>
                <ng-container *ngIf="this.quote.leadChannel || this.quote.leadType then check else allow"></ng-container>
                <ng-template #check>
                    <button  nz-button 
                             nzType="primary" 
                             (click)="navigateWithoutSaving()" 
                             [disabled]="(this.quote.leadChannel && this.quote.selectedChannel == null) || (this.quote.leadType && this.quote.selectedType == null)">
                        <i nz-icon nzType="left-circle" nzTheme="fill"></i>
                        Just Checking,Continue
                    </button>
                </ng-template>
                <ng-template #allow>
                    <button nz-button nzType="primary" (click)="navigateWithoutSaving()">
                        <i nz-icon nzType="left-circle" nzTheme="fill"></i>
                        Just Checking,Continue
                    </button>
                </ng-template>
            </div>
        </div>

        <!--Divider-->
        <nz-divider *ngIf="this.quote.leadChannel || this.quote.leadType"></nz-divider>

        <!--Follow up & Closing-->
        <div nz-row [nzJustify]="'center'">
            <div nz-col nzSpan="24" style="text-align: center;">
                <div nz-row [nzGutter]="15" [nzJustify]="'center'">
                    <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" style="text-align: center;" *ngIf="!this.quote.isWIP">
                        <!-- FOLLOW UP -->
                        <br>
                        <nz-card  nzTitle="FOLLOW UP LATER" class="nav-card" >
                            <div nz-row>
                                <nz-input-group [nzAddOnAfter]="addOnAfterTemplate">
                                    <textarea [(ngModel)]="statusComment" nz-input placeholder="Add Comment" [maxLength]="450" rows="2"
                                    [disabled]="(this.quote.leadChannel && this.quote.selectedChannel == null) || (this.quote.leadType && this.quote.selectedType == null)"></textarea>
                                </nz-input-group>
                                <ng-template #addOnAfterTemplate>
                                    <span style="color: grey;"><small>{{statusComment.length}}/450</small></span>
                                </ng-template>
                            </div>  
                            <br>
                            <div nz-row>
                                <div nz-col nzSpan="24">
                                    <nz-select [ngModel]="followUpSelect" nzPlaceHolder="Select Follow Up Time" style="width: 60%;" (ngModelChange)="followUpChange($event)"
                                    [disabled]="(this.quote.leadChannel && this.quote.selectedChannel == null) || (this.quote.leadType && this.quote.selectedType == null)">                          
                                        <nz-option [nzValue]="1" nzLabel="In 15 mins"></nz-option>
                                        <nz-option [nzValue]="2" nzLabel="In 1 hour"></nz-option>
                                        <nz-option [nzValue]="3" nzLabel="In 2 hours"></nz-option>
                                        <nz-option [nzValue]="4" nzLabel="Lunch Time"  [nzDisabled]="checkLunchDisabled()"></nz-option>
                                        <nz-option [nzValue]="5" nzLabel="Tomorrow" ></nz-option>
                                        <nz-option [nzValue]="6" nzLabel="In 2 days"></nz-option>
                                        <nz-option [nzValue]="7" nzLabel="Calendar"></nz-option>
                                    </nz-select>
                                </div>                 
                            </div>
                            <br>
                            <div nz-row>
                                <div nz-col nzSpan="24" *ngIf="followUpSelect === 7">
                                    Follow Up On: <br>
                                    <nz-date-picker [nzDisabledDate]="disabledDate" nzFormat="yyyy-MM-dd HH:mm" nzAllowClear="false" [(ngModel)]="followUpDate" nzPlaceHolder="Select Date" #followUpDatePicker (ngModelChange)="updateQuoteStateWithAction(PosAuditEntryType.FollowUpLater)"
                                        class="txtareaDatePicker" [disabled]="(this.quote.leadChannel && this.quote.selectedChannel == null) || (this.quote.leadType && this.quote.selectedType == null)">
                                    </nz-date-picker>
                                </div>
                            </div>
                        </nz-card>
                    </div>
                    <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" style="text-align: center;">
                        <!-- CUSTOMER ACTIONS -->
                        <br>
                        <nz-card  nzTitle="CLOSE LEAD" class="nav-card">
                            <div nz-row>
                                <div nz-col nzSpan="24">
                                    <nz-select [ngModel]="leadSelect" nzPlaceHolder="Select Reason " style="width: 60%;" (ngModelChange)="closeLead($event)"
                                    [disabled]="(this.quote.leadChannel && this.quote.selectedChannel == null) || (this.quote.leadType && this.quote.selectedType == null)"> 
                                        <nz-option [nzValue]="1" nzLabel="Bought From Competitor"></nz-option>      
                                        <nz-option [nzValue]="2" nzLabel="Customer Not Reachable"></nz-option>
                                        <nz-option [nzValue]="3" nzLabel="Price Checking"></nz-option>
                                        <nz-option [nzValue]="4" nzLabel="Commited to Buy"></nz-option>
                                        <nz-option [nzValue]="5" nzLabel="Other"></nz-option>
                                    </nz-select>
                                </div>                 
                            </div>
                            <br>
                            <div nz-row [nzJustify]="'center'" *ngIf="leadSelect === 5" [nzGutter]="[0, 12]">
                                <div nz-col nzSpan="24">
                                    OTHER:<br>
                                    <nz-input-group [nzAddOnAfter]="addOnAfterTemplate">
                                        <textarea [(ngModel)]="statusComment" nz-input placeholder="Add Comment" [maxLength]="450" rows="2"
                                        [disabled]="(this.quote.leadChannel && this.quote.selectedChannel == null) || (this.quote.leadType && this.quote.selectedType == null)"></textarea>
                                    </nz-input-group>
                                    <ng-template #addOnAfterTemplate>
                                        <span style="color: grey;"><small>{{statusComment.length}}/450</small></span>
                                    </ng-template>
                                </div>
                                
                                <div nz-col nzSpan="24">
                                    <button nz-button nzType="primary" (click)="updateQuoteStateWithAction(PosAuditEntryType.ClosedOther)"
                                    [disabled]="(this.quote.leadChannel && this.quote.selectedChannel == null) || (this.quote.leadType && this.quote.selectedType == null)">
                                        <i nz-icon nzType="save" nzTheme="fill"
                                            ></i>Save
                                    </button>
                                </div>
                            </div>
                            <br>
                            <!-- <div nz-row [nzJustify]="'center'">
                                <div nz-col nzSpan="24">
                                    <button nz-button nzType="primary" (click)="updateQuoteStateWithAction(PosAuditEntryType.ClosedOther)"
                                    [disabled]="(this.quote.leadChannel && this.quote.selectedChannel == null) || (this.quote.leadType && this.quote.selectedType == null)">
                                        <i nz-icon nzType="save" nzTheme="fill"
                                            ></i>Save
                                    </button>
                                </div>
                            </div> -->
                        </nz-card>
                    </div>
                </div>
            </div>
        </div>

    </div>
</nz-modal>

<!-- LEad Classification Modal -->

<nz-modal [nzVisible]="isLeadClassificationModalVisible" nzTitle="Classify Lead" nzOkText="Continue" (nzOnOk)="executeMethodToRunWhenLeadClassified()" (nzOnCancel)="isLeadClassificationModalVisible = false; navPathAway='';"  nzWidth="800px"
[nzOkLoading]="quote.isDirty" [nzFooter]="null">
    <div *nzModalContent>
        <ng-container *ngIf="this.quote.leadChannel || this.quote.leadType then classification"></ng-container>
    </div>
</nz-modal>

<ng-template #classification>
     <!--Classification Section-->
     <div nz-row nzJustify="center">
        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" style="text-align: center;" *ngIf="this.quote.leadChannel">
            <label><b>Lead Channel</b></label><br />
            <div nz-row nzAlign="bottom" *ngIf="this.authService.user.storeRoomEnabled">
                <div nz-col nzSpan="24">
                    <span style="margin-right: 10px;">Delay Stock Pick : </span>
                    <nz-switch [(ngModel)]="isPickable"></nz-switch>
                    <nz-divider></nz-divider>
                </div>
            </div>
            <nz-button-group>
                <button nz-button [disabled]="quote.selectedChannel === 3" (click)="classifyLead(1,1)" [nzType]="quote.selectedChannel === 1 ? 'primary' : 'default'">Walk-in</button>
                <button nz-button [disabled]="quote.selectedChannel === 3" (click)="classifyLead(2,1)" [nzType]="quote.selectedChannel === 2 ? 'primary' : 'default'">Telephonic</button>
                <button nz-button [disabled]="quote.selectedChannel === 3" (click)="classifyLead(3,1)" [nzType]="'primary'" *ngIf="quote.selectedChannel === 3">Online</button>
              </nz-button-group>
        </div>
        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" style="text-align: center;" *ngIf="this.quote.leadType">
            <label><b>Lead Type</b></label><br />
                <button nz-button (click)="classifyLead(1,2)" [nzType]="quote.selectedType === 1 ? 'primary' : 'default'">Budget</button>
                <button nz-button (click)="classifyLead(2,2)" [nzType]="quote.selectedType === 2 ? 'primary' : 'default'">Value</button>
                <button nz-button (click)="classifyLead(3,2)" [nzType]="quote.selectedType === 3 ? 'primary' : 'default'">Premium</button>
        </div>
     </div>
     
     <!-- <div nz-row [nzGutter]="5" [nzJustify]="'center'">
        <div nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" style="text-align: center;" *ngIf="this.quote.leadChannel">
            <label><b>Lead Channel</b></label><br>
            <nz-select [nzDisabled]="quote.selectedChannel === 3" nzread (ngModelChange)="classifyLead($event,1)" [(ngModel)]="this.quote.selectedChannel" nzPlaceHolder="Select Lead Channel" style="width: 60%;" [nzStatus]="this.quote.selectedChannel == null ? 'error' : ''">
                <nz-option [nzValue]="1" nzLabel="Walk-in"></nz-option>
                <nz-option [nzValue]="2" nzLabel="Telephonic"></nz-option>
                <nz-option [nzValue]="3" nzLabel="Online" *ngIf="this.quote.selectedChannel == 3"></nz-option>
            </nz-select>
            
            <p class="text-danger" *ngIf="this.quote.selectedChannel == null "><i>Lead channel required</i></p>
        </div>
        <div  nz-col nzXs="24" nzSm="24" nzMd="12" nzLg="12" nzXl="12" style="text-align: center;" *ngIf="this.quote.leadType">
            <label><b>Lead Type</b></label><br>
            <nz-select (ngModelChange)="classifyLead($event,2)" [(ngModel)]="this.quote.selectedType" nzPlaceHolder="Select Lead Type" style="width: 60%;" [nzStatus]="this.quote.selectedType == null ? 'error' : ''">
                <nz-option [nzValue]="1" nzLabel="Budget "></nz-option>
                <nz-option [nzValue]="2" nzLabel="Value"></nz-option>
                <nz-option [nzValue]="3" nzLabel="Premium"></nz-option>
            </nz-select>
            <p class="text-danger" *ngIf="this.quote.selectedType == null "><i>Lead Type required</i></p>
        </div>
    </div> -->

</ng-template>


<!-- Booking Modal -->
<nz-modal [(nzVisible)]="isBookingModalVisible" nzTitle="Book Fitment Slot" (nzOnCancel)="isBookingModalVisible = false" [nzFooter]="null" nzWidth="700px">

    <div *nzModalContent>
        <div nz-row nzGutter="10" [nzJustify]="'center'">
            <div nz-col nzXs="24" nzSm="24" nzMd="12">
                <div [ngStyle]="{ width: '300px' }">
                    <nz-calendar [nzFullscreen]="false" (nzSelectChange)="onBookingDateSelected($event)"></nz-calendar>
                </div>
            </div>
            <div nz-col nzXs="24" nzSm="24" nzMd="12">
                <nz-spin [nzSpinning]="isLoadingBookingSlots">
                    <div style="margin-bottom: 10px;">Date: {{bookingSelectedDate}}</div>

                    <button nz-button nzType="primary" (click)="onSlotSelected(i)" style="width: 100%; text-align: left; margin-bottom: 5px;" *ngFor="let i of bookingSlots"><span style="text-align: left;">Time: {{i.slotTime.toString().padStart(2,"0").substring(0,5)}}</span><small class="float-right"><i>{{i.bookings}} bookings</i></small></button>

                    <div *ngIf="bookingSlots.length === 0" style="padding-top: 20px; text-align: center;">
                        <i nz-icon nzType="minus-circle" nzTheme="fill" style="color: darkred; font-size: 3rem; padding-bottom: 20px;"></i>

                        <div style="text-align: center;">No Time Slots</div>
                    </div>
                </nz-spin>


            </div>
        </div>
    </div>
</nz-modal>

<!-- FLEET MODALS -->
 <!-- SB Fleet -->
 <nz-modal [(nzVisible)]="isSbAuthModalVisible" nzClosable="true" nzTitle="Please Provide Fleet Details" (nzOnCancel)="isSbAuthModalVisible=false;" (nzOnOk)="onSbAuthSubmit()" [nzFooter]="null">
    <div *nzModalContent>
        <form [formGroup]="sbauthForm" class="text-center">
            <nz-form-item>                
                <nz-form-label nzFor="odometer" [nzSpan]="6">Milage</nz-form-label>
                <nz-form-control nzErrorTip="Enter valid mileage">
                    <input class="inputdiv" maxlength="6" nz-input name="odometer" formControlName="odometer" placeholder="Vehicle Milage" type="number">
                </nz-form-control>                
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzFor="drivername" [nzSpan]="6">Driver Name</nz-form-label>
                <nz-form-control nzErrorTip="Enter valid Driver Name">
                    <input class="inputdiv" nz-input name="drivername" formControlName="drivername" placeholder="Driver Name">
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzFor="drivercell" [nzSpan]="6">Driver Contact No</nz-form-label>
                <nz-form-control nzErrorTip="Enter a valid cell no">
                    <input class="inputdiv" maxlength="10" nz-input name="drivercell" formControlName="drivercell" placeholder="Driver Cell" type="text">
                </nz-form-control>
            </nz-form-item>
        </form>
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-2 offset-5">
                    <button nz-button nzType="default" [nzLoading]="isLoading" (click)="onSbAuthSubmit()"><span nz-icon nzType="cloud-upload" nzTheme="outline"></span> Submit</button>
                </div>
            </div>
        </div>
    </div>
</nz-modal>

<nz-modal [(nzVisible)]="isFleetAuthModalVisible" [nzTitle]="fleetAuthModalTitle" (nzOnCancel)="isFleetAuthModalVisible = false" [nzFooter]="null" nzWidth="800px">
    <div *nzModalContent>
        <app-salesman-fleet-auth 
          [quote]="quote" 
          (onFleetAuthClose)="isFleetAuthModalVisible = false" 
          (onFleetAuthAuthorise)="quote.isAuthorised = true">
          
        </app-salesman-fleet-auth>
    </div>
    <ng-template #fleetAuthModalTitle>
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <span *ngIf="quote.authType === 1"> eAuth Authorisation</span>
          <span *ngIf="quote.authType === 2"> Priority Path Authorisation</span>
          <div *ngIf="fleetAuthComponent; else loading" style="margin-right: 40px;">
            <button 
              nz-button 
              nzType="primary" 
              (click)="downloadSteps()" 
              [disabled]="!fleetAuthComponent.hasProcessDocument || fleetAuthComponent.isProcessDocumentLoading"
              [nzLoading]="fleetAuthComponent.isProcessDocumentLoading"
              style="margin-right: 10px;">
              Download Steps
            </button>
            <button 
              nz-button 
              nzType="primary" 
              (click)="downloadQuote()">
              Quote
            </button>
          </div>
          <ng-template #loading>
            <span>Loading...</span>
          </ng-template>
        </div>
      </ng-template>
</nz-modal>




<!-- Invoice Modal-->
<nz-modal [(nzVisible)]="isInvoiceModalVisible" nzTitle="Invoice Customer" (nzOnCancel)="isInvoiceModalVisible = false" [nzFooter]="null" nzWidth="700px">
    <div *nzModalContent>
        <div nz-row nzJustify="center">
            <div nz-row nzSpan="24" style="text-align: center; " nzJustify="space-around" nzAlign="middle" >
                <h6  style="margin-top: 10px;">Customer Reference:</h6>
                <input nz-input [(ngModel)]="quote.customerOrderReference" placeholder="Customer Reference Number"  style="margin-top: 10px; width: 50%;">
            </div>
            <div nz-col nzSpan="24" style="text-align: center; margin-top: 20px;">
                <h3>Total Invoice Amount: R{{this.quoteTotalIncVat.toFixed(2).toString()}}</h3>
            </div>
            <div nz-col nzSpan="24" style="text-align: center; ">
            <h4 style="margin-top: 10px;">Payments</h4>
                <div *ngFor="let payment of quote.payments; let i = index" nz-col nzSpan="24" style="text-align: center; margin-top: 10px;"  >  
                    <ng-container *ngIf="payment.amount != 0" >              
                        <div nz-row nzSpan="24" nzJustify="space-around"  >
                                <h6  style="margin-top: 10px;">Method</h6>
                                <nz-radio-group [(ngModel)]="payment.paymentTypeId" nzButtonStyle="solid" style="margin-top: 10px; width: 50%;">                       
                                    <label nz-radio-button [nzValue]="1">Card</label>
                                    <label nz-radio-button [nzValue]="2">Cash</label>
                                    <label nz-radio-button [nzValue]="3">EFT</label>
                                    <label nz-radio-button [nzValue]="4">Other</label>
                            </nz-radio-group>
                        </div>
                        <div nz-row nzSpan="24" style="text-align: center;" nzJustify="space-around" nzAlign="middle" >
                            <h6>Amount</h6>
                            <input type="number" nz-input [(ngModel)]="payment.amount" [placeholder]="payment.amount" style="margin-top: 10px; width: 50%;" (ngModelChange)="updatePaymentAmount(i)" [max]="quoteTotalIncVat" >
                            
                    </div>
                    <nz-divider></nz-divider>
                </ng-container>
                      
                </div>
                
                <div nz-row nzSpan="24" nzJustify="space-around"  >
                    <h6  style="margin-top: 10px;">Invoice Distribution Method</h6>
                    <nz-radio-group [(ngModel)]="quote.invoiceDeliveryMethod" nzButtonStyle="solid" style="margin-top: 10px; width: 50%;">                       
                        <label nz-radio-button [nzValue]="4">WhatsApp</label>
                        <label nz-radio-button [nzValue]="2">Email</label>
                        <label nz-radio-button [nzValue]="0">None</label>
                </nz-radio-group>
            </div>
        </div>
            <div nz-col nzSpan="24" style="text-align: center; margin-top: 20px;">
                <button nz-button nzType="primary" (click)="submitInvoice()" [nzLoading]="isLoading" >
                    <i nz-icon nzType="save" nzTheme="outline"></i> Submit Invoice
                </button>
            </div>
        </div>
    </div>
</nz-modal>

<!-- Customer Release Modal -->

<nz-modal [(nzVisible)]="isCustomerReleaseModalVisible" nzClosable="true" nzTitle="Do you want to release the vehicle to the customer now?" (nzOnCancel)="navToSalesPage()" [nzFooter]="null">
    <ng-container *nzModalContent>
        <nz-row nzJustify="space-around" nzAlign="middle" *ngIf="!isSafeGoModalVisible">
            <nz-col nzSpan="6">
                <button nz-button nzType="primary" nzSize="large" (click)="sendSafeGoWhatsApp()">Send Now <i nz-icon nzType="whats-app" nzTheme="outline"></i></button>
            </nz-col>
            <nz-col nzSpan="6">
                <button nz-button nzType="default" nzSize="large" (click)="navToSalesPage()">Send Later</button>
            </nz-col>
        </nz-row>
        <!-- <nz-row nzJustify="center" nzAlign="middle" nzGutter="16" *ngIf="isSafeGoModalVisible">
            <nz-col nzSpan="18">
                <input nz-input type="number" placeholder="Enter SafeGo Pin" [(ngModel)]="safeGoPin" />
            </nz-col>
            <nz-col nzSpan="6">
                <button nz-button nzType="primary" (click)="verifySafeGo(safeGoPin)"  style="text-align: center;">Verify</button>
            </nz-col>
        </nz-row> -->
    </ng-container>
</nz-modal>


<nz-modal *ngIf="authService.hasClaims(['WIP'])" [(nzVisible)]="isOrderTypeModalVisible" nzTitle="Woud you like to add the following items to your next replenishment?" nzWidth="980px" [nzFooter]="null" (nzOnCancel)="isLoading = false;isOrderTypeModalVisible = false;">
    <ng-container *nzModalContent>
        <nz-spin [nzSpinning]="demandAssignmentLoading">
        <nz-table #replenishmentLinesTable class="quote-line-selection" [nzData]="quote.lines" [nzFrontPagination]="false" [nzShowPagination]="false" nzSize="small">
            <thead>
                <tr>
                    <th>Stock Code</th>
                    <th>Description</th>
                    <th>SOH</th>
                    <th>MSL</th>
                    <th>Order Qty</th>
                    <!-- <th>Supplier</th> -->
                    <!-- <th>Model Stock</th>
                    <th>MSL</th> -->
                    <!-- <th>Replenishment Method</th> -->
                    <th>Replenishment</th>
                    <th>True demand</th>
                    <!-- <th></th> -->
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let line of replenishmentLinesTable.data">
                    <tr *ngIf="line.stockTypeId == 1">
                        <td>
                            {{ line.stockCode }}
                            <span
                                *ngIf="line.stockReplenishmentId !== 0 && line.msl > 0"
                                nz-icon
                                nzType="info-circle"
                                nzTheme="outline"
                                nz-popover
                                nzPopoverTrigger="click"
                                nzPopoverPlacement="right"
                                [nzPopoverContent]="'The item ' + line.stockCode + ' is already part of your model stock and will be added to your next replenishment'"
                                style="margin-right: 6px; cursor: pointer; color: var(--warningcolor);">
                            </span>
                        </td>
                        <td>{{ line.description }}</td>
                        <!-- <td>{{ line.replenishmentSupplierSoh }}</td> -->
                        <td>{{ line.customerSoh }}</td>
                        <td>{{line.msl}}</td>
                        <td>
                            <nz-input-number
                                [ngModel]="getReplenishmentQuantity(line)"
                                (ngModelChange)="setReplenishmentQuantity(line, $event)"
                                [nzMin]="0"
                                [nzMax]="line.replenishmentSupplierSoh"
                                [nzStep]="1"
                                [attr.aria-label]="'Quantity for ' + line.stockCode">
                            </nz-input-number>
                        </td>
                        <!-- <td>{{line.replenishmentSupplierName}}</td> -->
                        <!-- <td>
                            <span *ngIf="line.stockReplenishmentId !== 0" nz-icon nzType="check" nzTheme="outline" style="color: green;"></span>
                            <span *ngIf="line.stockReplenishmentId === 0" nz-icon nzType="close" nzTheme="outline" style="color: red;"></span>
                        </td>
                        <td>{{ line.msl }}</td> -->
                        <!-- <td>
                            <nz-radio-group
                                [ngModel]="replenishmentTypeByLine.get(line)"
                                (ngModelChange)="setReplenishmentType(line, $event)"
                                >
                                <label nz-radio [nzValue]="'replenishment'">Add to replenishment</label>
                                <label nz-radio [nzValue]="'trueDemand'">True demand</label>
                            </nz-radio-group>
                        </td> -->
                        
                        <td style="justify-content: center;">
                            <!-- <button
                                *ngIf="line.replenishmentSupplierSoh >0"
                                nz-button
                                nzType="primary"
                                nzSize="small"
                               
                                (click)="replenishmentCheckout(line)">
                                <span  nz-icon nzType="truck" nzTheme="outline"></span>
                            </button> -->
                            <button  *ngIf="line.replenishmentSupplierSoh >0" nz-button nzType="primary" style="margin-left: 20px;" [nz-tooltip]="'Replenish from ' + line.replenishmentSupplierName + ' ' + line.replenishmentSupplierSoh + ' units available'"   (click)="replenishmentCheckout(line)">
                                <span nz-icon nzType="shopping-cart" nzTheme="outline"></span>
                            </button>
                            <span *ngIf="line.replenishmentSupplierSoh <= 0">Stock unavailable for replenishment</span>
                        </td>
                        <td>
                             <!-- <button
                                nz-button
                                nzType="primary"
                                nzSize="small"
                                (click)="setReplenishmentType(line,'trueDemand')">
                                True demand
                            </button> -->
                            <button  nz-button nzType="primary" style="margin-left: 5px;"  (click)="setReplenishmentType(line,'trueDemand')">
                                <div style="display: flex;">
                                    <span nz-icon nzType="shopping-cart" nzTheme="outline" ></span>
                                    <span nz-icon nzType="fast-forward" nzTheme="outline" style="margin-left:1px;"></span>
                                </div>
                            </button>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </nz-table>
        </nz-spin>
        <div *ngIf="hasTrueDemandSelection" style="margin-top: 20px;">
            <h3>True Demand Supplier Options <a style="color: red; margin-left: 10px;" (click)="setReplenishmentType(lastLine,'replenishment')">
                <span  nz-icon nzType="stop"></span></a>
                <input nz-input [(ngModel)]="trueDemandOrderComment"  placeholder="comment (optional)"  style="margin-left: 30px; width: 30%;">
            </h3>
            <nz-table #trueDemandSuppliers class="quote-line-selection" [nzData]="trueDemandSupplierOptions" [nzFrontPagination]="false" [nzShowPagination]="false" nzSize="small">
             <thead>
                <tr>
                    <th>Stock Code</th>
                    <th>Supplier</th>
                    <th>SLA</th>
                    <th>SOH</th>
                    <th>Buying Price</th>
                    <th>Order</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let line of trueDemandSuppliers.data">
                    <tr>
                        <td>{{ line.stockCode }}</td>
                        <td>{{ line.supplier}}</td>
                        <td>{{ line.sla}}</td>
                        <td>{{ line.soh}}</td>
                        <td>{{ line.price}}</td>
                        <td style="white-space: nowrap;">
                            <nz-input-number
                                [ngModel]="getTrueDemandSupplierQuantity(line)"
                                (ngModelChange)="setTrueDemandSupplierQuantity(line, $event)"
                                [nzMin]="0"
                                [nzMax]="getAvailableStock(line.soh)"
                                [nzStep]="1"
                                [attr.aria-label]="'Quantity to add for ' + line.stockCode">
                            </nz-input-number>
                            <button nz-button nzType="primary" style="margin-left: 8px;" [nz-tooltip]="'Place Order'"  (click)="checkSupplierRequirements(line)">
                                <span nz-icon nzType="shopping-cart" nzTheme="outline"></span>
                            </button>
                        </td>
                    </tr>
                   
                </ng-container>
            </tbody>
            </nz-table>
        </div>
        <div class="text-center" style="margin-top: 10px;">
            <button nz-button nzType="primary" (click)="this.assignWIP(true);">Proceed without ordering</button>
        </div>
    </ng-container>
</nz-modal>

<nz-modal *ngIf="this.showRequirementInputs" [(nzVisible)]="showRequirementInputs" nzTitle="Please fill in these fields required by the supplier" nzWidth="980px" [nzFooter]="null" (nzOnCancel)="showRequirementInputs = false;">
    <ng-container *nzModalContent>
        <nz-row  style="width: 600px; margin-left: 190px;" *ngIf="this.supplierRequirements['ext_ref'] == 1">
            <nz-col nzSpan="12">Order reference: </nz-col>
            <nz-col nzSpan="12"><input nz-input [(ngModel)]="requiredOrderRef"  style="width: 100%; border:solid 2px grey;"></nz-col>
        </nz-row >
        <nz-row  style="width: 600px; margin-left: 190px; margin-top: 10px;" *ngIf="this.supplierRequirements['reg'] == 1">
            <nz-col nzSpan="12">Vehicle registration: </nz-col>
            <nz-col nzSpan="12"><input nz-input [(ngModel)]="requiredVReg"  style="width: 100%; border:solid 2px grey;"></nz-col>
        </nz-row >
        <nz-row  style="width: 600px; margin-left: 190px; margin-top: 10px;" *ngIf="this.supplierRequirements['make'] == 1">
            <nz-col nzSpan="12">Vehicle make: </nz-col>
            <nz-col nzSpan="12"><input nz-input [(ngModel)]="requiredMake"  style="width: 100%; border:solid 2px grey;"></nz-col>
        </nz-row >
        <nz-row  style="width: 600px; margin-left: 190px; margin-top: 10px;" *ngIf="this.supplierRequirements['milage'] == 1">
            <nz-col nzSpan="12">Mileage: </nz-col>
            <nz-col nzSpan="12"><input nz-input [(ngModel)]="requiredMileage"  style="width: 100%; border:solid 2px grey;"></nz-col>
        </nz-row >
        <nz-row  style="width: 600px; margin-left: 190px; margin-top: 10px;" *ngIf="this.supplierRequirements['salesman'] == 1">
            <nz-col nzSpan="12">Salesman: </nz-col>
            <nz-col nzSpan="12"><input nz-input [(ngModel)]="requiredSalesman"  style="width: 100%; border:solid 2px grey;"></nz-col>
        </nz-row >

         <hr style="width: 600px; margin-left: 190px; margin-top: 10px; border-bottom: solid 1px grey;">
        <nz-radio-group style=" margin-left: 190px; margin-top: 10px;"  [(ngModel)]="requiredDelivery"
            nzButtonStyle="solid" nzSize="small" *ngIf="this.supplierRequirements['isDeliveryOptionShowing'] == true">
            <label nz-radio-button [nzValue]="false">Pick Up</label>
            <label nz-radio-button [nzValue]="true">Delivery</label>
        </nz-radio-group>
        <nz-row  style="width: 600px; margin-left: 190px; margin-top: 10px;" *ngIf="this.supplierRequirements['delivery'] == 1 && this.requiredDelivery == true">
            <nz-col nzSpan="12">Delivery address: </nz-col>
            <nz-col nzSpan="12"><input nz-input [(ngModel)]="requiredDeliveryAddress"  style="width: 100%; border:solid 2px grey;"></nz-col>
        </nz-row>
        <nz-row style="margin-top: 10px;">
            <nz-col nzSpan="12"></nz-col>
            <nz-col nzSpan="12">
                 <button nz-button nzType="primary" (click)="this.checkSupplierRequirements(this.checkoutLine);">Checkout   <span nz-icon nzType="shopping-cart" nzTheme="outline"></span></button>
            </nz-col>
        </nz-row>

    </ng-container>
    
</nz-modal>

